export default __webpack_public_path__ + "media/images/client-logos/openbrix-ac408ab8b417a183df4e5f31caedea82.png";